import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap";
import axios from 'axios';
import { BASE_URL } from "../../../constants";

function Areas() {
    const [areas, setAreas] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
    const [perPageDropdownOpen, setPerPageDropdownOpen] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [errMsg, setErrMsg] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [filter, setFilter] = useState('all');
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [currentPage, perPage, searchQuery, filter]);

    const toggleFilterDropdown = () => {
        setFilterDropdownOpen(prevState => !prevState);
    };

    const togglePerPageDropdown = () => {
        setPerPageDropdownOpen(prevState => !prevState);
    };

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const fetchData = () => {
        const token = localStorage.getItem('token');
        if (token) {
            fetch(`${BASE_URL}/area/list?page_no=${currentPage}&per_page=${perPage}&q=${searchQuery}&filter=${filter}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        const formattedAreas = data.result.data.map(area => {
                            const formattedArea = { ...area };
                            formattedArea.created_at = new Date(area.created_at).toLocaleDateString('en-US');
                            return formattedArea;
                        });
                        setAreas(formattedAreas);
                        setTotalPages(data.result.meta_info.total_pages);
                    } else {
                        console.error("Error: Unable to fetch amenities data.");
                    }
                })
                .catch(error => console.error("Error fetching data:", error));
        } else {
            console.error("Error: Authorization token is missing.");
        }
    };

    const handleAddArea = () => {
        navigate('/area/add');
    };

    const handleEditArea = (id) => {
        navigate(`/area/edit/${id}`, {
            state: {
                areas: areas
            }
        });
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePerPageChange = (value) => {
        setPerPage(value);
        setCurrentPage(1);
    };

    const handleFilterChange = (selectedFilter) => {
        switch (selectedFilter) {
            case "All":
                setFilter('all')
                break;
            case "Custom":
                setFilter('custom')
                break;
            case "Common":
                setFilter('common')
                break;
            default:
                setFilter('all')

        }
        setCurrentPage(1);
    };

    const handleDeleteArea = async (id) => {

        // Ask for confirmation
        const confirmed = window.confirm("Are you sure you want to delete this amenity?");

        // If user confirms deletion
        if (confirmed) {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.delete(`${BASE_URL}/area/delete/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setErrMsg(response.data.message);
                setIsDeleted(true);
                fetchData();

            } catch (error) {
                setErrMsg(error);
            }
        }
    };


    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

            <Row>
                <Col xs="6">
                    <h4 className="mt-0">Amenities</h4>
                </Col>

                <Col xs="6" className="text-end">
                    <Button color="primary" onClick={handleAddArea}>Add Amenity</Button>
                </Col>
            </Row>


            <Card>
                <CardBody>
                    <Row className="my-3">

                        <Col xs="6">
                            <Dropdown style={{ position: 'relative', top: '-18px' }} isOpen={filterDropdownOpen} toggle={toggleFilterDropdown}>
                                <DropdownToggle caret color="primary">
                                    {/* Filter by:  */}
                                    {filter}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => handleFilterChange("All")}>All</DropdownItem>
                                    {/* <DropdownItem onClick={() => handleFilterChange("Custom")}>Custom</DropdownItem> */}
                                    <DropdownItem onClick={() => handleFilterChange("Common")}>Common</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>

                        <Col xs="6" className="text-end">
                            <Input
                                type="text"
                                placeholder="Search by title"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
                            />
                        </Col>
                    </Row>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Common</th>
                                {/* <th>Custom</th> */}
                                {/* <th>Property name</th> */}
                                <th>Created at</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {areas.map((area, index) => (
                                <tr key={index}>
                                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                                    <td>{area.title}</td>
                                    <td>{area.is_common === 1 ? "YES" : "NO"}</td>
                                    {/* <td>{area.is_custom === 1 ? "YES" : "NO"}</td> */}
                                    {/* <td>{area.name}</td> */}
                                    <td>{area.created_at}</td>
                                    <td>
                                        <Button color="danger" onClick={() => handleDeleteArea(area.id)}>Delete</Button>
                                        <span style={{ marginRight: "5px" }}></span>
                                        <Button color="warning" onClick={() => handleEditArea(area.id)}>Edit</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </Table>
                </CardBody>

                <Row>
                    <Col xs="4">
                        <div style={{ marginLeft: '25px' }}>
                            <Dropdown isOpen={perPageDropdownOpen} toggle={togglePerPageDropdown}>
                                <DropdownToggle caret color="primary">
                                    Per Page: {perPage}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
                                    <DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
                                    <DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
                                    <DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </Col>

                    <Col xs="8" className="text-right">
                        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>
                            <Pagination aria-label="Page navigation example">
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                     
                                        previous
                                        onClick={() => handlePageClick(currentPage - 1)}
                                    />
                                </PaginationItem>

                                {currentPage > 3 && (
                                    <>
                                        <PaginationItem>
                                            <PaginationLink onClick={() => handlePageClick(1)}>
                                                1
                                            </PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem disabled>
                                            <PaginationLink>...</PaginationLink>
                                        </PaginationItem>
                                    </>
                                )}

                                {Array.from({ length: 5 }, (_, i) => {
                                    const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
                                    return (
                                        page <= totalPages && (
                                            <PaginationItem key={page} active={currentPage === page}>
                                                <PaginationLink
                                                   
                                                    onClick={() => handlePageClick(page)}
                                                >
                                                    {page}
                                                </PaginationLink>
                                            </PaginationItem>
                                        )
                                    );
                                })}

                                {currentPage < totalPages - 2 && (
                                    <>
                                        <PaginationItem disabled>
                                            <PaginationLink>...</PaginationLink>
                                        </PaginationItem>
                                        <PaginationItem>
                                            <PaginationLink onClick={() => handlePageClick(totalPages)}>
                                                {totalPages}
                                            </PaginationLink>
                                        </PaginationItem>
                                    </>
                                )}

                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                       
                                        next
                                        onClick={() => handlePageClick(currentPage + 1)}
                                    />
                                </PaginationItem>
                            </Pagination>

                        </div>
                    </Col>
                </Row>
            </Card>
        </div>
    );
}

export default Areas;
